import React, { Component } from "react";

export default class GraphLabels extends Component {
  render() {
    const { x, y, payload } = this.props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={20}
          fontSize={14}
          textAnchor="middle"
          fill="#666"
          transform="rotate(0)"
        >
          {payload.value}
        </text>
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GraphLabels.jsx